module.exports = __webpack_public_path__ + "img/icon-help-white.f7a770ba.svg";